import React from 'react';
import GrantAccessTemplate from '../grant-access-template';

function RegisteredNotGrantedTemplate () {

	return (
		<GrantAccessTemplate/>
	)

}

export default RegisteredNotGrantedTemplate;
